import { useInterval } from "hooks/useInterval";
import { useState } from "react";

export interface UseDetectStripeModalOptions {
    interval?: number;
    polling?: boolean;
}

/**
 * Check if the Stripe modal is open.
 * @link https://github.com/stripe/stripe-js/issues/599#issuecomment-2316156282
 * Stripe has no way to tell if their modal is open, and when using a dialog .showmodal(), it opens overtop of the Stripe modal.
 * This hook checks if the Stripe modal is open
 */
export function useDetectStripeModal(
    { interval, polling }: UseDetectStripeModalOptions = {
        interval: 250,
        polling: false
    }
) {
    const [open, setOpen] = useState(false);

    // Continually check if there is a div with the class of .StripeElement
    useInterval(
        () => {
            const stripeModal = document.querySelector(
                'div[tabindex="-1"] > iframe[name*="__privateStripeFrame"]'
            );
            setOpen(!!stripeModal);
        },
        interval,
        { disable: !polling }
    );

    return open;
}
